import React from "react";
import { Table, Modal, Button } from "react-bootstrap";
import DocumentAPI from "../../api/DocumentAPI";
import Display from "../../util/Display";
import Util from "../../util/Util";
import { FaDownload, FaTrash } from "react-icons/fa";
import Const from "../../util/Constants";
import { reactLocalStorage } from "reactjs-localstorage";
import { IoIosEye } from "react-icons/io";

class PropertyDocTable extends React.Component {
  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).document;
    this.state = { inApiCall: true, documents: [], showImage: false, previewImage: "", };

    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() {
    DocumentAPI.getInnerList(
      this.props.type,
      this.props.id,
      this.onReceived,
      this.onFail
    );
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, documents: [] });
      DocumentAPI.getInnerList(
        this.props.type,
        props.id,
        this.onReceived,
        this.onFail
      );
    }
  }

 onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  
  onReceived = (res) => {
    if (this.props.onCount) {
      this.props.onCount("document", res.count);
    }
    this.setState({ inApiCall: false, documents: res.data });
  };

  //Detect Image
  isImage = (url) => {
  const clean = url.split("?")[0];
    return /\.(jpeg|jpg|png|gif|webp|bmp)$/i.test(clean);
  };
  openImage = (url) =>{
     this.setState({ showImage: true, previewImage: url });
  };
   closeImage = () => {
    this.setState({ showImage: false, previewImage: "" });
  };

  onDownload = async (index, position) => {
    const doc = this.state.documents[index];
    const files = doc.files.substring(1, doc.files.length - 1).split(Const.Opt);
    const res = await DocumentAPI.getPublicMediaUrl(files[position]);
    window.open(res.url, "_blank");
  };
  onDelete = (indx) =>
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete",
      "Delete",
      "No",
      () => {
        this.setState({ ...this.state, inApiCall: true });
        DocumentAPI.delete(
          this.state.documents[indx].id,
          this.onDeleteSuccess,
          this.onFail
        );
      }
    );
  onDeleteSuccess = () => {
    Util.showNotification(
      "Successful",
      "Documnet deleted successfully",
      "success"
    );
    this.props.reload();
  };

  showList = () => {
    const docs = [];
    for (let i = 0; i < this.state.documents.length; i++) {
      const doc = this.state.documents[i];
      const files = doc.images; //.filter(image => !this.ifImage(image.url));
      if (files.length === 0) {
        continue;
      }
      docs.push(
        <tr key={`document_${i + 1}`}>
          <td>{Util.serverStringToDisplayDateTime(doc.created_date)}</td>
          <td>{Display.FieldValue(doc, "file_type", this.model.fields)}</td>
          <td>{Display.FieldValue(doc, "description", this.model.fields)}</td>
          <td>
            {files.map((file, j) => (
              <div key={`doc_${i}_${j}`} style={{ width: "120px" }} className="mb-1">
                {this.isImage(file.url) ? (
                  <button
                    onClick={() => this.openImage(file.url)}
                    className="btn btn-success btn-sm w-100 d-flex align-items-center justify-content-center"
                  >
                    <IoIosEye style={{ marginRight: 6 }} />
                    View
                  </button>
                ) : (
                 
                  <a
                    className="btn btn-primary btn-sm w-100 d-flex align-items-center justify-content-center"
                    href={file.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaDownload style={{ marginRight: 6 }} />
                    Download
                  </a>
                )}
              </div>
            ))}
          </td>

          <td>{Display.ModelLabelValue("user", doc.created_by)}</td>
          <td>
            {this.Delete && (
              <span onClick={() => this.onDelete(i)} className="buttons delete">
                <FaTrash /> Delete
              </span>
            )}
          </td>
        </tr>
      );
    }
    return docs;
  };

  render() {
    let uiDocuments = this.showList();
    if (this.state.documents.length === 0) {
      uiDocuments = (
        <tr>
          <td colSpan="6">No Records Found</td>
        </tr>
      );
    }
    return (
      <>
      <div className="row col-12  col-sm-12">
        <h2>{this.props.title ? this.props.title : "Documents"}</h2>
        <Table striped bordered responsive hover size="sm">
          <thead>
            <tr>
              <th>Created Date</th>
              <th>File Type</th>
              <th>Description</th>
              <th>Download</th>
              <th>Created By</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>{uiDocuments}</tbody>
        </Table>
      </div>
              <Modal
          show={this.state.showImage}
          onHide={this.closeImage}
          centered
          size="lg"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Image Preview</Modal.Title>
          </Modal.Header>

          <Modal.Body className="text-center">
            <img
              src={this.state.previewImage}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "10px",
              }}
            />
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeImage}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        </>
    );
  }
}

export default PropertyDocTable;
